import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import { Card, Form, Button, Row, Col, Table, Dropdown } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaSearch, FaFilter, FaEraser } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';

class Planos extends Component {
    constructor(props) {
        super(props);
        this.onChangeBusca = this.onChangeBusca.bind(this);
        this.onClickPagina = this.onClickPagina.bind(this);
        this.buscaPlano = this.buscaPlano.bind(this);
        this.limpaFiltro = this.limpaFiltro.bind(this);
        this.handleChangeFiltros = this.handleChangeFiltros.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            filtro_programa_id: '',
            filtro_programa_nome: '',
            page_numb: 1,
            loading: true,
        };
    }

    componentDidMount() {
        this.consultaRegistro(this.state.busca, this.state.page_numb);
    }

    consultaRegistro(busca, page_numb = 1) {
        let url = `/planos/?nome=${busca}&page=${page_numb}`;
        if (this.state.filtro_programa_id) {
            url += `&programa_id=${this.state.filtro_programa_id}`;
        }

        api.get(url)
            .then(response => {
                this.setState({
                    loading: false,
                    error: "",
                    listRegistros: response.data
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao consultar planos, tente novamente.';

                if (error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                } else if (error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg
                });
            });
    }

    handleChangeFiltros(event, fieldName) {
        if (fieldName === 'programa_id') {
            this.setState(prevState => ({
                filtro_programa_id: event.value,
                filtro_programa_nome: event.label,
            }));
        }
    }

    carregarProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    renderRows() {
        if ('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0) {
            return this.state.listRegistros.results.map((item) =>
                <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{item.dados_programa.nome}</td>
                    <td>{(item.status === true) ? 'Ativo' : 'Inativo'}</td>
                    <td>
                        <Button variant="light" href={"/planos/edit/" + item.id} size="sm">
                            <FaRegEdit /> Editar
                        </Button>
                    </td>
                </tr>
            );
        }

        return (
            <tr>
                <td colSpan={5}>Nenhum plano cadastrado</td>
            </tr>
        );
    }

    onChangeBusca(e) {
        this.setState({
            busca: e.target.value
        });
    }

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });

        this.consultaRegistro(this.state.busca, num_page);
    }

    buscaPlano(e) {
        e.preventDefault();

        this.setState({
            loading: true,
        });

        this.consultaRegistro(this.state.busca);
    }

    limpaFiltro() {
        this.setState({
            busca: '',
            filtro_programa_id: null,
            filtro_programa_nome: ''
        }, () => {
            this.consultaRegistro(this.state.busca, 1);
        });
    }

    render() {
        const customStyles = {
            option: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
            singleValue: (provided) => ({
                ...provided,
                fontSize: '13px',
            }),
        };

        if (!hasPerm('view_planos')) {
            return <Navigate to='/sem-permissao' />;
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Planos</h4>
                    </Col>
                    <Col sm={6} lg={6} className="text-end">
                        <Button variant="secondary" href="/planos/add" className="mb-3" size="sm">
                            <FaPlus /> Adicionar Plano
                        </Button>
                    </Col>
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row>
                            <Col sm={12} lg={12} className="mb-3 d-flex justify-content-end">
                                <Dropdown className="d-inline">
                                    <Dropdown.Toggle variant="light" size="sm">
                                        <FaFilter /> Filtrar
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <div className="drop-filter">
                                            <Form method="get" onSubmit={this.buscaPlano}>
                                                <Row>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="busca"
                                                                value={this.state.busca}
                                                                onChange={this.onChangeBusca}
                                                                placeholder="Nome do plano"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={12} xs={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Programa</Form.Label>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={this.carregarProgramas}
                                                                defaultOptions
                                                                name="programa_id"
                                                                placeholder="Nome do Programa"
                                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                                value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                                                styles={customStyles}
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <Button type="submit" variant="light" size="sm">
                                                    <FaSearch /> Filtrar
                                                </Button>

                                                <Button className="ms-1" type="button" variant="light" size="sm" onClick={() => this.limpaFiltro()}>
                                                    <FaEraser /> Limpar Filtro
                                                </Button>
                                            </Form>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Nome</th>
                                    <th>Programa</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                    <tr>
                                        <td colSpan={5}>Carregando...</td>
                                    </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={5}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}
                            </tbody>
                        </Table>
                        {
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 &&
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default withRouter(Planos);
